<template>
    <div class="modal-column account-set-settings">
        <div class="modal-column-body">
            <vxe-form :data="accountingPersonnel" title-align="right" title-width="100">
                <vxe-form-item title="记账人" span="12">
                    <vxe-input v-model="accountingPersonnel.jzName" :maxlength="50" clearable/>
                </vxe-form-item>
                <vxe-form-item title="复核人" span="12">
                    <vxe-input v-model="accountingPersonnel.fhName" :maxlength="50" clearable/>
                </vxe-form-item>
                <vxe-form-item title="制单人" span="12">
                    <vxe-input v-model="accountingPersonnel.zdName" :maxlength="50" clearable/>
                </vxe-form-item>
                <vxe-form-item title="出纳" span="12">
                    <vxe-input v-model="accountingPersonnel.cashierName" :maxlength="50" clearable/>
                </vxe-form-item>
                <vxe-form-item title="单位负责人" span="12">
                    <vxe-input v-model="accountingPersonnel.unitLeaderName" :maxlength="50" clearable/>
                </vxe-form-item>
                <vxe-form-item title="财务负责人" span="12">
                    <vxe-input v-model="accountingPersonnel.financialLeaderName" :maxlength="50" clearable/>
                </vxe-form-item>
            </vxe-form>
        </div>
        <div class="modal-column-btn">
            <vxe-button status="warning" :disabled="loading" @click="emits('close')">取消</vxe-button>
            <vxe-button status="primary" :loading="loading" @click="save">保存</vxe-button>
        </div>
    </div>
</template>

<script setup>
import {onMounted, reactive, ref} from 'vue';
import CommonConfig from '@api/CommonConfig';
import {message} from 'heyui.ext';

const emits = defineEmits(['close', 'success']);
const configKey = 'accountSetSettings';
const loading = ref(false);
const loadFailed = ref(false);
const settings = ref({});
const accountingPersonnel = reactive({
    jzName: '',
    fhName: '',
    zdName: '',
    unitLeaderName: '',
    financialLeaderName: '',
    cashierName: '',
});

const normalizeValue = (value) => String(value ?? '');
const normalizePersonnel = () => ({
    jzName: normalizeValue(accountingPersonnel.jzName),
    fhName: normalizeValue(accountingPersonnel.fhName),
    zdName: normalizeValue(accountingPersonnel.zdName),
    unitLeaderName: normalizeValue(accountingPersonnel.unitLeaderName),
    financialLeaderName: normalizeValue(accountingPersonnel.financialLeaderName),
    cashierName: normalizeValue(accountingPersonnel.cashierName),
});

const load = async () => {
    loading.value = true;
    try {
        const {data} = await CommonConfig.getConfigValue(configKey);
        settings.value = data && typeof data === 'object' ? data : {};
        Object.assign(accountingPersonnel, settings.value.accountingPersonnel || {});
        loadFailed.value = false;
    } catch (error) {
        loadFailed.value = true;
        message.error('财务设置加载失败');
    } finally {
        loading.value = false;
    }
};

const save = async () => {
    if (loadFailed.value) {
        message.error('财务设置未成功加载，请关闭后重试');
        return;
    }
    loading.value = true;
    try {
        const personnel = normalizePersonnel();
        await CommonConfig.updateConfigValue({
            title: '账套设置',
            keyFlag: configKey,
            valueJson: {
                ...settings.value,
                accountingPersonnel: {
                    ...(settings.value.accountingPersonnel || {}),
                    ...personnel,
                },
            },
        });
        Object.assign(accountingPersonnel, personnel);
        message('保存成功');
        emits('success');
    } catch (error) {
        message.error('财务设置保存失败');
    } finally {
        loading.value = false;
    }
};

onMounted(load);
</script>

<style scoped>

.account-set-settings .modal-column-body {
    padding: 24px 28px 8px;
}

.account-set-settings :deep(.vxe-form--item-content) {
    width: 100%;
}

</style>
